import randomBytes from "randombytes";
export const generateRandomHex = (length = 24)=>{
    return new Promise((resolve, reject)=>{
        randomBytes(length, function(err, buffer) {
            if (err) {
                return reject(err);
            }
            resolve(buffer.toString("hex"));
        });
    });
};
